__turbopack_context__.v({
  "breadcrumbs": "styles-module-scss-module__7rKKvq__breadcrumbs",
  "text": "styles-module-scss-module__7rKKvq__text",
});
